import { atom } from 'recoil';
import { RecoilAtomKey } from '../../recoilConstantKey';

const SectorListByNumberAtom = atom({
      key: RecoilAtomKey.SectorListByNumberKey,
      default: {}
})
const LeadsBySectorAtom = atom({
      key: RecoilAtomKey.LeadsBySectorKey,
      default: []
})

const QuetionsBySectorAtom = atom({
      key: RecoilAtomKey.QuetionsBySectorKey,
      default: {}
})

const B2bFormDataAtom = atom({
      key: RecoilAtomKey.B2bFormDataKey,
      default: {
            'L4.1': null,
            'L5.1': null,
            'L6.1': null,
            l1_answers: null,
            l1_answer_2: null,
            l2_answers: null,
            relationship_manager: null,
            current_patner_feedback: '',
            current_company: null,
            supplier_id: null,
            representative: null,
            call_back_preference: null,
            current_patner_feedback_reason: '',
            prefered_patners: []
      }
})

export { SectorListByNumberAtom, LeadsBySectorAtom, QuetionsBySectorAtom, B2bFormDataAtom }